import { render, staticRenderFns } from "./student-gmail-modal.vue?vue&type=template&id=b56dd7d4&scoped=true&lang=pug&"
import script from "./student-gmail-modal.vue?vue&type=script&lang=js&"
export * from "./student-gmail-modal.vue?vue&type=script&lang=js&"
import style0 from "./student-gmail-modal.vue?vue&type=style&index=0&id=b56dd7d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56dd7d4",
  null
  
)

export default component.exports